function highlightTextToHtml(text: string, query: string) {
	if (!query) return text;

	const escaped = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	const regex = new RegExp(`(${escaped})`, 'gi');

	return text.replace(regex, '<mark>$1</mark>');
}

export default highlightTextToHtml;
